import 'jspdf-autotable';
import React from 'react';

import {Icon} from '@udemy/icons';
import {Tooltip} from '@udemy/react-popup-components';

import {useGetInstructorAccountBalanceQuery} from '../../generated/graphql';
import styles from './section.module.less';

export const AccountBalanceSection = () => {
    const {data} = useGetInstructorAccountBalanceQuery();

    const rawAmount = data?.instructorAccountBalance?.amount ?? 0;
    // Format to show -$X.XX for negative values
    const formattedAmount =
        rawAmount < 0 ? `-$${Math.abs(rawAmount).toFixed(2)}` : `$${rawAmount.toFixed(2)}`;

    return (
        <div className={styles['section-container']}>
            <h1 className="ud-heading-xl">{gettext('Account Balance')}</h1>
            <div className={styles['info-container-account-balance']}>
                <div className="ud-heading-xxxl">
                    <strong>{formattedAmount}</strong>
                </div>
                <div className={styles['account-balance-tooltip']}>
                    <Tooltip
                        trigger={<Icon glyph="info-outline" label={false} />}
                        className={styles['title-icon']}
                        canToggleOnHover={true}
                        detachFromTarget={true}
                    >
                        {gettext(
                            'Balance remaining in your account which has not yet been paid out. These funds will be included in the upcoming payout cycle if all requirements are met.',
                        )}
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};
